<!-- 首页 -->
<template>
  <div class="cv-rl">
    <h1>CV / RL
      <!-- <Button style="margin-left: 40px" type="primary" @click="toUpload">上传CV搜集信息表</Button> -->
      <!-- <Button v-if="collectInfo.cvCollectInfoUrl" style="margin-left: 8px" @click="download(collectInfo.cvCollectInfoUrl)">下载</Button> -->
    </h1>
    <ul v-if="cvlist.length>0 || rllist.length>0">
      <li v-for="(item,index) in cvlist"
          :key="`cv${index}`"
          class="animated animatedFadeIn">
        <zlr-card-service title='Curriculum Vitae'
                          style="width: 400px;"
                          kind="CV"
                          bgText="CV"
                          :explainList="item.backLogs|backLogsFilters"
                          circle="waiting"
                          @click="linkHandle(item,'CV', index)"
                          :dotted=true
                          :dottedList="item.emEdit | dottedfilter">
          <div>{{ item.title }}</div>
        </zlr-card-service>
      </li>
      <li v-for="(item,index) in rllist"
          :key="`rl${index}`"
          class="animated animatedFadeIn">
        <zlr-card-service title="Reference Letter"
                          style="width: 400px;"
                          kind="CV"
                          bgText="RL"
                          :explainList="item.backLogs|backLogsFilters"
                          circle="waiting"
                          @click="linkHandle(item,'RL',index)"
                          :dotted=true
                          :dottedList="item.emEdit | dottedfilter">
          <div>{{ item.title }}</div>
        </zlr-card-service>
      </li>
    </ul>

    <zlr-empty v-else></zlr-empty>

    <div v-if="showUpload">
      <zlr-modal v-model="showUpload">
        <div>
          <zlr-upload v-model="cv" :path="'collect/cv'" :format="['doc','docx']"/>
          <Button type="primary" v-if="cv" @click="upload">确定</Button>
        </div>
      </zlr-modal>
    </div>

  </div>
</template>
<script>
// api
import { getMeterialCVList, getMeterialRLList } from '@/api/material'
// components
import ZlrCardService from '_c/card-service/card-service'
import ZlrEmpty from '_c/empty/empty'
import { mapState } from 'vuex'
import ZlrUpload from '_c/upload/upload'
import ZlrModal from '_c/modal/modal'
import materialCollectService from '@/api/material/material-collect'
import { ossSecretLink } from '@/api/oss'

export default {
  name: 'cv-rl',
  components: {
    ZlrModal,
    ZlrUpload,
    ZlrCardService,
    ZlrEmpty
  },
  data () {
    return {
      cvlist: [],
      rllist: [],
      showUpload: false,
      cv: undefined,
      collectInfo: {}
    }
  },
  computed: {
    ...mapState({
      'userInfo': (state) => state.user.userInfo
    })
  },
  mounted () {
    this.getMeterialList()
    this.getMeterialRLList()
    //this.getCollectInfo()
  },
  methods: {
    async getCollectInfo () {
      const { code, data } = await materialCollectService.getCollectInfo()
      if (code === 0) {
        this.collectInfo = data.model
      }
    },
    getMeterialList () {
      getMeterialCVList({}).then(res => {
        this.cvlist = res.data.model.bills
        this.cvModuleFinish = res.data.model.moduleFinish
      })
    },
    getMeterialRLList () {
      getMeterialRLList({}).then(res => {
        this.rllist = res.data.model.bills
        this.rlModuleFinish = res.data.model.moduleFinish
      })
    },
    linkHandle (item, type, index) {
      let { onlyExpert, id } = item
      // 判断当前所有的CV或者RL 的最后一条以及接口返回moduleFinish字段来判断模块里面评价导师是否显示 "你觉得这个Module对你有帮助吗？"
      let name = ''
      if (onlyExpert) {
        name = type === 'CV' ? 'cv-rl-cv-expert' : 'cv-rl-rl-expert'
      } else {
        name = type === 'CV' ? 'cv-rl-cv-mentor' : 'cv-rl-rl-mentor'
      }
      let params = type === 'CV' ? { cvId: id || 0 } : { rlId: id || 0 }
      this.$router.push({
        name,
        params: {
          ...params
        },
        query: {
          type: Number(onlyExpert)
        }
      })
    },
    toUpload () {
      this.showUpload = true
    },
    async upload () {
      const { code, message } = await materialCollectService.uploadCollectInfo(this.cv, 'CV')
      if (code === 0) {
        await this.getCollectInfo()
        this.$zlr_message('操作成功', 'success')
        this.showUpload = false
      } else {
        this.$zlr_message(message, 'error')
      }
    },
    download (url) {
      ossSecretLink({
        dir: url
      }).then(res => {
        window.open(res.data.url)
      })
    }
  },
  filters: {
    backLogsFilters (logs) {
      if (logs.length === 0) return []
      let arr = []
      logs.forEach(item => {
        arr.push({ title: item.content, color: '#85A5FF' })
      })
      return arr
    },
    dottedfilter (emEdit) {
      if (emEdit.length === 0) return []
      let arr = []
      let smEditActvie = emEdit.filter(item => item.status === 'EDITED').length
      arr.push({
        conNum: emEdit.length,
        activeNum: smEditActvie
      })
      return arr
    }
  }
}
</script>
<style lang='less' scoped>
</style>
